import React, { useState } from 'react';
import { PlusIcon, SearchIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useStore } from '../../contexts/StoreContext';
import { Modal } from '../ui/Modal';
import { VehicleEditor } from './VehicleEditor';
import { Vehicle } from '../../types/catalog';
import { getEffectiveOffer } from '../../utils/finance';
import { formatARS, formatDate, formatPct, isExpired } from '../../utils/format';
export function VehiclesPanel() {
  const {
    localVehicles,
    brands,
    deleteVehicle,
    updateVehicle,
    catalogSync
  } = useStore();
  const [editing, setEditing] = useState<Vehicle | null | 'new'>(null);
  const [q, setQ] = useState('');
  const list = localVehicles.filter(v => {
    const b = brands.find(x => x.id === v.brandId)?.name ?? '';
    return `${b} ${v.model} ${v.version}`.toLowerCase().includes(q.toLowerCase());
  });
  return <div data-id="element-302" data-mp="2csh9reeottfm">
      <div className="mb-5 rounded-xl border border-neon/30 bg-neon/10 p-4 text-sm" data-id="element-303" data-mp="2cs7jrqtn7m9x">
        <p className="font-semibold text-white" data-id="element-304" data-mp="1115ey5soynmn">
          Inventario de la planilla:{' '}
          {catalogSync.status === 'loading' ? 'conectando…' : catalogSync.error && catalogSync.sheetCount === 0 ? 'sin conexión' : `${catalogSync.sheetCount} ${catalogSync.sheetCount === 1 ? 'unidad publicada' : 'unidades publicadas'}`}
          {catalogSync.lastSync && <span className="font-normal text-mist" data-id="element-305" data-mp="i29p16nv8vem"> · actualizado {formatDate(catalogSync.lastSync)}</span>}
        </p>
        <p className="mt-1 text-mist" data-id="element-306" data-mp="db1fmamjda1g">
          Las unidades reales se cargan y editan en la pestaña INVENTARIO_0KM de Google Sheets y aparecen en la página en hasta 1 minuto. Esta lista muestra sólo las unidades de ejemplo guardadas en este navegador.
        </p>
        <button type="button" onClick={catalogSync.refresh} className="btn btn-ghost mt-3 h-9" data-id="element-307" data-mp="491vh9g85pua">Actualizar ahora</button>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-308" data-mp="3qhl141ldsmco">
        <div className="relative sm:w-80" data-id="element-309" data-mp="3gtxtjoi6tdjr">
          <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-mist" aria-hidden data-id="element-310" data-mp="3gsw76nvq14mq" />
          <label htmlFor="ad-vq" className="sr-only" data-id="element-311" data-mp="3lr7g8we6zb3w">Buscar unidad</label>
          <input id="ad-vq" className="input pl-9" placeholder="Buscar marca, modelo o versión" value={q} onChange={e => setQ(e.target.value)} data-id="element-312" data-mp="37vdjfbqp0c75" />
        </div>
        <button onClick={() => setEditing('new')} className="btn btn-primary" data-id="element-313" data-mp="3fax7al3jyzd">
          <PlusIcon className="h-4 w-4" aria-hidden data-id="element-314" data-mp="8ee470kn0f9z" /> Nueva unidad
        </button>
      </div>

      <div className="mt-5 overflow-x-auto rounded-2xl border border-line" data-id="element-315" data-mp="3qsn04l4mvbkp">
        <table className="w-full min-w-[820px] text-sm" data-id="element-316" data-mp="3qqkbo5j4pqi3">
          <thead className="bg-panel text-left text-xs text-mist" data-id="element-317" data-mp="3ut6yfs0y0l8f">
            <tr data-id="element-318" data-mp="meow86xonzwq">
              <th className="p-3 font-medium" data-id="element-319" data-mp="me6puhhb45b3">Unidad</th>
              <th className="p-3 font-medium" data-id="element-320" data-mp="mclvosywmodr">Precio</th>
              <th className="p-3 font-medium" data-id="element-321" data-mp="r66u2m4etkdh">Condición</th>
              <th className="p-3 font-medium" data-id="element-322" data-mp="2bvkc3oz81ri4">Vigencia</th>
              <th className="p-3 font-medium" data-id="element-323" data-mp="2btzh5y8zw6jq">Estado</th>
              <th className="p-3 font-medium" data-id="element-324" data-mp="26x0t9xfxcvtz">Actualizado</th>
              <th className="p-3 font-medium" data-id="element-325" data-mp="26umyzqt2jnnh"><span className="sr-only" data-id="element-326" data-mp="2llwy7lmopsqd">Acciones</span></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-327" data-mp="2gmke38n76zrh">
            {list.map(v => {
            const ctx = getEffectiveOffer(v, brands);
            const expired = ctx ? isExpired(ctx.offer.validUntil) : false;
            return <tr key={v.id} className="align-middle" data-id="element-328" data-mp="1nz6airozv5ye">
                  <td className="p-3" data-id="element-329" data-mp="22um6j294xbxf">
                    <div className="flex items-center gap-3" data-id="element-330" data-mp="22wgvqsrfvq7b">
                      <img src={v.images[0]} alt="" className="h-10 w-14 rounded object-cover" data-id="element-331" data-mp="1xv9m0o5qkgy0" />
                      <div data-id="element-332" data-mp="3e9jbjllpsbqf">
                        <p className="font-semibold" data-id="element-333" data-mp="3e8q0w9jmx230">{brands.find(b => b.id === v.brandId)?.name} {v.model}</p>
                        <p className="text-xs text-mist" data-id="element-334" data-mp="39ag3dsaftpe8">{v.version} · {v.year}</p>
                      </div>
                    </div>
                  </td>
                  <td className="p-3 font-medium" data-id="element-335" data-mp="1nsfggvrldewl">{formatARS(v.price)}</td>
                  <td className="p-3" data-id="element-336" data-mp="1ruisbli6alie">
                    {ctx && <>
                        <p data-id="element-337" data-mp="1wtlyxadswzsh">{formatPct(ctx.offer.tna)} TNA · {ctx.source === 'unidad' ? 'Propia' : 'Marca'}</p>
                        <p className={`text-xs ${ctx.offer.verified ? 'text-ok' : 'text-warn'}`} data-id="element-338" data-mp="21syk7qp0xysy">{ctx.offer.verified ? 'Verificada' : 'Sin verificar'}</p>
                      </>}
                  </td>
                  <td className={`p-3 text-xs ${expired ? 'text-danger' : 'text-mist'}`} data-id="element-339" data-mp="2bi9pf28sijbk">{ctx ? formatDate(ctx.offer.validUntil) : '—'}{expired ? ' · vencida' : ''}</td>
                  <td className="p-3" data-id="element-340" data-mp="2kj7y3xu6bf0h">
                    <button onClick={() => updateVehicle(v.id, {
                  published: !v.published
                })} className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${v.published ? 'border-ok/30 text-ok' : 'border-line text-mist'}`} data-id="element-341" data-mp="2kk977wrmprfk">
                      {v.published ? 'Publicada' : 'Borrador'}
                    </button>
                  </td>
                  <td className="p-3 text-xs text-mist" data-id="element-342" data-mp="2pothwnkodb28">{formatDate(v.updatedAt)}</td>
                  <td className="p-3" data-id="element-343" data-mp="2ln86z7rpb6uo">
                    <div className="flex justify-end gap-2" data-id="element-344" data-mp="2lojdvggg0uq0">
                      <button onClick={() => setEditing(v)} className="btn btn-ghost h-9" data-id="element-345" data-mp="3ibnzncq3xwc0">Editar</button>
                      <button onClick={() => {
                    if (window.confirm(`¿Eliminar ${v.model} ${v.version}? Esta acción no se puede deshacer.`)) {
                      deleteVehicle(v.id);
                      toast.success('Unidad eliminada');
                    }
                  }} className="btn btn-danger h-9" data-id="element-346" data-mp="3denxve0ajfqp">
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>

      <Modal open={editing !== null} onClose={() => setEditing(null)} title={editing === 'new' ? 'Nueva unidad' : 'Editar unidad'} wide data-id="element-347" data-mp="1zfvtybsmk8jz">
        {editing !== null && <VehicleEditor key={editing === 'new' ? 'new' : editing.id} vehicle={editing === 'new' ? null : editing} onDone={() => setEditing(null)} data-id="element-348" data-mp="1pmx5ctx4oi0d" />}
      </Modal>
    </div>;
}